import { render, staticRenderFns } from "./DenunciaInserir.vue?vue&type=template&id=67eb5a5b&lang=pug"
import script from "./DenunciaInserir.vue?vue&type=script&lang=js"
export * from "./DenunciaInserir.vue?vue&type=script&lang=js"
import style0 from "./DenunciaInserir.vue?vue&type=style&index=0&id=67eb5a5b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports